const options = { method: 'GET' };
const version = '1.35';
const now = new Date().toString();
const baseUrl = `https://${window.location.host}/collections/`;
const menuSpinner = [document.getElementById('menu-spinner'), document.getElementById('spinner'), document.getElementById('mobmenu-spinner')];
const menuMakeString = `${url}/makes?subscription-key=${key}`;
const menuRegoFilters = [document.getElementById('menu-rego-filters'), document.getElementById('rego-filters'), document.getElementById('mob-menu-rego-filters')];
const menuRego = [document.getElementById('menu-rego'), document.getElementById('rego'), document.getElementById('mob-menu-rego')];
const menuRegoSearch = [document.getElementById('menu-regoSearch'), document.getElementById('regoSearch'), document.getElementById('mob-menu-regoSearch')];
const menuStates = [document.getElementById('menu-states'), document.getElementById('states'), document.getElementById('mob-menu-states')];
const menusbr = [document.getElementById('menu-sbr'), document.getElementById('sbr'), document.getElementById('mob-menu-sbr')];
const menuVehicleFilters = [document.getElementById('menu-vehicle-filters'), document.getElementById('vehicle-filters'), document.getElementById('mob-menu-vehicle-filters')];
const menuMake = [document.getElementById('menu-makes'), document.getElementById('makes'), document.getElementById('mob-menu-makes')];
const menuYear = [document.getElementById('menu-years'), document.getElementById('years'), document.getElementById('mob-menu-years')];
const menuModel = [document.getElementById('menu-models'), document.getElementById('models'), document.getElementById('mob-menu-models')];
const menuSeries = [document.getElementById('menu-series'), document.getElementById('series'), document.getElementById('mob-menu-series')];
const menuLookup = [document.getElementById('menu-lookup'), document.getElementById('lookup'), document.getElementById('mob-menu-lookup')];
const menusbv = [document.getElementById('menu-sbv'), document.getElementById('sbv'), document.getElementById('mob-menu-sbv')];
const overlay = document.getElementById('rs-popup-overlay');
const popup = document.getElementById('rs-popup');
const regoError = document.getElementById('regoError');
const vehicleError = document.getElementById('vehicleError');
const vehicleConfirm = document.getElementById('vehicleConfirm');
const productSwitch = [document.getElementById('productTypeMenu'), document.getElementById('productType'), document.getElementById('productTypeMenuMob')];
const wheelSwitches = [document.getElementById('wheelSwitchMenu'), document.getElementById('wheelSwitch'), document.getElementById('wheelSwitchMenuMob')];
const tyreSwitches = [document.getElementById('tyreSwitchMenu'), document.getElementById('tyreSwitch'), document.getElementById('tyreSwitchMenuMob')];
const eventlocale = ['Desktop Menu', 'Home page/Collection page', 'Mobile Menu']
let reject = false;
let rejectCarry;
let searchCarry;
let historyObject = [];
let historyList = localStorage.getItem('vehicleList');
if (historyList) {
    historyList = historyList.split(',');
    for (i = 0; i < historyList.length; i++) {
        if (typeof localStorage.getItem(`fitmentInfo${historyList[i]}`) == 'string') {
            historyObject.push(JSON.parse(localStorage.getItem(`fitmentInfo${historyList[i]}`)));
        } else {
            historyObject.push(localStorage.getItem(`fitmentInfo${historyList[i]}`));
        }
    }
}

//listener for disclaimer close button
document.getElementById('rs-close').addEventListener('click', function () {
    regoError.style.display = 'none';
    vehicleError.style.display = 'none';
    overlay.style.display = 'none';
    popup.style.display = 'none';
});

//listener for vehicle selector retry/refresh button
document.getElementById('vRetry').addEventListener('click', function () {
    location.reload();
});

if (document.getElementById('vRetryMob')) {
    document.getElementById('vRetryMob').addEventListener('click', function () {
        location.reload();
    });
}

document.addEventListener('DOMContentLoaded', function () {
    for (j = 0; j < menuRegoSearch.length; j++) {
        let menuArray = [menusbr[j], menusbv[j], document.getElementById('sbt'), document.getElementById('sbw')];
        let filterArray = [menuRegoFilters[j], menuVehicleFilters[j], document.getElementById('tyre-search'), document.getElementById('wheel-search')];
        if (j != 1) {
            menuArray = [menusbr[j], menusbv[j]];
            filterArray = [menuRegoFilters[j], menuVehicleFilters[j]];
        }
        if (menusbv[j]) {
            changeSearchListener(menusbr[j], menuArray, filterArray);
        }
        if (menusbr[j]) {
            changeSearchListener(menusbv[j], menuArray, filterArray);
        }
        if (document.getElementById('sbt') && j == 1) {
            changeSearchListener(document.getElementById('sbt'), menuArray, filterArray);
        }
        if (document.getElementById('sbw') && j == 1) {
            changeSearchListener(document.getElementById('sbw'), menuArray, filterArray);
        }

        //Recall last search type
        if (localStorage.getItem('prodSwitch') == 'wheels') {
            if (productSwitch[j]) {
                productSwitch[j].checked = true;
                wheelSwitches[j].classList.add('productSwitchActive');
                wheelSwitches[j].classList.remove('productSwitchOff');
                tyreSwitches[j].classList.add('productSwitchOff');
                tyreSwitches[j].classList.remove('productSwitchActive');
            }
        }

        //load data for dropdowns and check for locally stored selection data
        if (menuRegoSearch[j]) {
            if (menuVehicleFilters[j]) {
                if (localStorage.getItem('makeList')) {
                    menuMake[j].innerHTML = localStorage.getItem('makeList');
                    menuMake[j].disabled = false;
                    if (localStorage.getItem('makeSelection')) {
                        menuMake[j].selectedIndex = localStorage.getItem('makeSelection');
                        makeMove(j);
                    }
                } else {
                    retrieveMakes(j);
                }

                //listen for inputs on dropboxes
                menuMake[j].addEventListener('input', function () {
                    let instance = menuMake.indexOf(this);
                    storageWiper(6);
                    dropDownSwitches(3, instance);
                    makeMove(instance);
                });

                menuYear[j].addEventListener('input', function () {
                    let instance = menuYear.indexOf(this);
                    storageWiper(4);
                    dropDownSwitches(2, instance);
                    yearMove(instance);
                });

                menuModel[j].addEventListener('input', function () {
                    let instance = menuModel.indexOf(this);
                    storageWiper(2);
                    dropDownSwitches(1, instance);
                    modelMove(instance);
                });

                menuSeries[j].addEventListener('input', function () {
                    let instance = menuSeries.indexOf(this);
                    seriesMove(instance);
                });

                //listen for click on search
                menuLookup[j].addEventListener('click', menuListen);
            }

            if (menuRegoFilters[j]) {
                if (localStorage.getItem('regoString')) {
                    menuRego[j].value = localStorage.getItem('regoString');
                    menuStates[j].disabled = false;
                    if (localStorage.getItem('regoState')) {
                        menuStates[j].selectedIndex = localStorage.getItem('regoState');
                        stateActive(j);
                    }
                }
                //listener for rego and states inputs to enable/disable inputs and search button
                menuRego[j].addEventListener('input', function () {
                    let instance = menuRego.indexOf(this);
                    if (menuRego[instance].value.length > 0) {
                        menuStates[instance].disabled = false;
                    } else if (menuRego[instance].value.length == 0) {
                        menuStates[instance].disabled = true;
                        menuStates[instance].selectedIndex = 0;
                        menuRegoSearch[instance].style.cursor = 'none';
                        menuRegoSearch[instance].style.opacity = '0.8';
                        menuRegoSearch[instance].disabled = true;
                    }
                });

                menuStates[j].addEventListener('input', function () {
                    let instance = menuStates.indexOf(this);
                    if (menuStates[instance].value.length > 0) {
                        stateActive(instance)
                    } else if (menuStates[instance].value.length == 0) {
                        menuRegoSearch[instance].style.cursor = 'none';
                        menuRegoSearch[instance].style.opacity = '0.8';
                        menuRegoSearch.disabled = true;
                        menuRegoSearch[instance].removeEventListener('click', function () {
                            onFind(instance);
                        });
                    }
                });
            }

            //listeners for tyres/wheels switches
            productSwitch[j].addEventListener('input', function () {
                let instance = productSwitch.indexOf(this);
                if (productSwitch[instance].checked) {
                    wheelSwitches[instance].classList.add('productSwitchActive');
                    wheelSwitches[instance].classList.remove('productSwitchOff');
                    tyreSwitches[instance].classList.add('productSwitchOff');
                    tyreSwitches[instance].classList.remove('productSwitchActive');
                    localStorage.setItem('prodSwitch', 'wheels');
                } else {
                    wheelSwitches[instance].classList.remove('productSwitchActive');
                    wheelSwitches[instance].classList.add('productSwitchOff');
                    tyreSwitches[instance].classList.remove('productSwitchOff');
                    tyreSwitches[instance].classList.add('productSwitchActive');
                    localStorage.setItem('prodSwitch', 'tyres');
                }
            });

            //listeners for tyres/wheels switches
            wheelSwitches[j].addEventListener('click', function () {
                let instance = wheelSwitches.indexOf(this);
                if (!productSwitch[instance].checked) {
                    productSwitch[instance].checked = true;
                    wheelSwitches[instance].classList.add('productSwitchActive');
                    wheelSwitches[instance].classList.remove('productSwitchOff');
                    tyreSwitches[instance].classList.add('productSwitchOff');
                    tyreSwitches[instance].classList.remove('productSwitchActive');
                    localStorage.setItem('prodSwitch', 'wheels')
                }
            });

            //listeners for tyres/wheels switches
            tyreSwitches[j].addEventListener('click', function () {
                let instance = tyreSwitches.indexOf(this);
                if (productSwitch[instance].checked) {
                    productSwitch[instance].checked = false;
                    wheelSwitches[instance].classList.remove('productSwitchActive');
                    wheelSwitches[instance].classList.add('productSwitchOff');
                    tyreSwitches[instance].classList.remove('productSwitchOff');
                    tyreSwitches[instance].classList.add('productSwitchActive');
                    localStorage.setItem('prodSwitch', 'tyres');
                }
            });


            //listeners for rego retry buttons
            document.getElementById('tryAgain').addEventListener('click', function () {
                if (menuRego[j]) {
                    menuRego[j].value = "";
                    menuStates[j].selectedIndex = 0;
                    menuStates[j].disabled = true;
                    menuRegoSearch[j].disabled = true;
                }
                regoError.style.display = 'none';
                vehicleError.style.display = 'none';
                overlay.style.display = 'none';
                popup.style.display = 'none';
                grecaptcha.reset();
            });


            if (document.getElementById('tryAgainMob')) {
                document.getElementById('tryAgainMob').addEventListener('click', function () {
                    if (menuRego[j]) {
                        menuRego[j].value = "";
                        menuStates[j].selectedIndex = 0;
                        menuStates[j].disabled = true;
                        menuRegoSearch[j].disabled = true;
                    }
                    regoError.style.display = 'none';
                    vehicleError.style.display = 'none';
                    overlay.style.display = 'none';
                    popup.style.display = 'none';
                    grecaptcha.reset();
                });
            };

            //Instance Fix Below

            //listener for rego use vehicle selector instead button
            document.getElementById('choose').addEventListener('click', function () {
                for (l = 0; l < menusbr.length; l++) {
                    if (menusbr[l]) {
                        if (!menusbv[l].classList.value.includes('switchActive')) {
                            if (menuVehicleFilters[l]) {
                                menuVehicleFilters[l].style.display = 'block';
                                menuVehicleFilters[l].style.opacity = 1;
                            }
                            if (menuRegoFilters[l]) {
                                menuRegoFilters[l].style.display = 'none';
                                menuRegoFilters[l].style.opacity = 0;
                            }
                            menusbr[l].classList.toggle('switchActive');
                            menusbv[l].classList.toggle('switchActive');
                            menusbr[l].classList.toggle('switchOff');
                            menusbv[l].classList.toggle('switchOff');
                        }
                    }
                }
                overlay.style.display = 'none';
                popup.style.display = 'none';
                grecaptcha.reset();
            });


            if (document.getElementById('chooseMob')) {
                document.getElementById('chooseMob').addEventListener('click', function () {
                    for (l = 0; l < menusbr.length; l++) {
                        if (menusbr[l]) {
                            if (!menusbv[l].classList.value.includes('switchActive')) {
                                if (menuVehicleFilters[l]) {
                                    menuVehicleFilters[l].style.display = 'block';
                                    menuVehicleFilters[l].style.opacity = 1;
                                }
                                if (menuRegoFilters[l]) {
                                    menuRegoFilters[l].style.display = 'none';
                                    menuRegoFilters[l].style.opacity = 0;
                                }
                                menusbr[l].classList.toggle('switchActive');
                                menusbv[l].classList.toggle('switchActive');
                                menusbr[l].classList.toggle('switchOff');
                                menusbv[l].classList.toggle('switchOff');
                            }
                        }
                    }
                    overlay.style.display = 'none';
                    popup.style.display = 'none';
                    grecaptcha.reset();
                });
            }
        }
    }
    vehicleHistory();
});

//Populate previous search history
function vehicleHistory() {
    let historyObject = [];
    let historyList = localStorage.getItem('vehicleList');
    if (historyList) {
        historyList = historyList.split(',');
        for (i = 0; i < historyList.length; i++) {
            if (typeof localStorage.getItem(`fitmentInfo${historyList[i]}`) == 'string') {
                historyObject.push(JSON.parse(localStorage.getItem(`fitmentInfo${historyList[i]}`)));
            } else {
                historyObject.push(localStorage.getItem(`fitmentInfo${historyList[i]}`));
            }
        }
    }
    if (localStorage.getItem('vehicleList')) {
        let historyContent = '';
        let historyMobContent = '';
        let historyCount = 0;
        let historyItem
        for (i = 0; i < historyObject.length; i++) {
            historyItem = historyObject[i];
            if (historyItem) {
                historyItem.expiry = Number(historyItem.expiry)
            };
            if (historyItem && historyItem.version == version && historyItem.expiry > Date.parse(now) && historyItem.makeModel) {
                historyCount = historyCount + 1;
                if (historyCount < 3) {
                    historyContent = `${historyContent}<div class="historyItem" data-id="${historyItem.id}">${historyItem.makeModel}</div>`
                }
                if (historyCount < 3) {
                    historyMobContent = `${historyMobContent}<h2 class="block-section-title previousSearchesMobile"><div class="historyItemMob" data-id="${historyItem.id}">${historyItem.makeModel}</div></h2>`
                }
            } else {
                localStorage.removeItem(`vehicleInfo${historyList[i]}`);
                if (historyItem) {
                    localStorage.removeItem(`fitmentInfo${historyItem.vehicle_id}`);
                }
                historyList.splice(historyList.indexOf(historyList[i]), 1)
                continue;
            }
            localStorage.setItem('vehicleList', historyList.toString());
        }
        if (historyContent.length > 0) {
            historyContent = `<h2 class="block-section-title previousSearches">Previously searched:${historyContent}</h2>`;
            historyMobContent = `<h2 class="block-section-title previousSearchesMobile">Previously searched:</h2>${historyMobContent}</h2>`;
            let deskHistory = document.getElementsByClassName('prevSearches');
            let mobHistory = document.getElementsByClassName('prevSearchesMob');
            let menuHistory = document.getElementsByClassName('prevSearchesMenu');
            for (i = 0; i < deskHistory.length; i++) {
                deskHistory[i].innerHTML = historyContent;
            };
            for (i = 0; i < mobHistory.length; i++) {
                mobHistory[i].innerHTML = historyMobContent;
            }
            for (i = 0; i < menuHistory.length; i++) {
                menuHistory[i].innerHTML = historyMobContent;
            }
        }
        let pastVehicles = document.getElementsByClassName('historyItem');
        for (i = 0; i < pastVehicles.length; i++) {
            pastVehicles[i].addEventListener('click', function () {
                pastVehicle(this.dataset.id, this.innerHTML, i, this.parentElement.parentElement.parentElement);
            });
        }
        let pastVehiclesMob = document.getElementsByClassName('historyItemMob');
        for (i = 0; i < pastVehiclesMob.length; i++) {
            pastVehiclesMob[i].addEventListener('click', function () {
                pastVehicle(this.dataset.id, this.innerHTML, i, this.parentElement.parentElement.parentElement);
            });
        }
    }
}

function stateActive(X) {
    menuRegoSearch[X].style.cursor = 'pointer';
    menuRegoSearch[X].style.opacity = '1';
    menuRegoSearch[X].disabled = false;
    menuRegoSearch[X].addEventListener('click', function () {
        menuRegoSearch[X].disabled = true;
        menuRegoSearch[X].style.cursor = 'none';
        menuRegoSearch[X].style.opacity = '0.8';
        onFind(X);
        setTimeout(() => {
            menuRegoSearch[X].disabled = false;
            menuRegoSearch[X].style.cursor = 'pointer';
            menuRegoSearch[X].style.opacity = '1';
        }, "1500");
    });
}

//fetch makes from API, render and store locally
async function retrieveMakes(X) {
    spinOn(menuSpinner[X]);
    let optionString = '';
    let resp = await fetch(menuMakeString, options);
    let ans = await resp.json();
    ans = nameSort(ans);
    for (i = 0; i < ans.length; i++) {
        optionString = `${optionString}<option data-idx="${i}" value="${ans[i].id}">${ans[i].display_name}</option>`;
    }
    menuMake[X].innerHTML = `<option class="default" value="" selected hidden>Vehicle Make</option>${optionString}`;
    localStorage.setItem('makeList', `<option class="default" value="" selected hidden>Vehicle Make</option>${optionString}`);
    spinOff(menuSpinner[X]);
    menuMake[X].disabled = false;
    return;
}

//fetch years from API, render and store locally
async function retrieveYears(X, Y) {
    spinOn(menuSpinner[X]);
    let currentYear = new Date().getFullYear();
    let resp = await fetch(menuMakeString, options);
    let ans = await resp.json();
    ans = nameSort(ans);
    let lowerYear = ans[Y].year_from;
    let upperYear = ans[Y].year_to;
    let optionString = '';
    for (i = lowerYear; i <= upperYear; i++) {
        optionString = `${optionString}<option value="${i}">${i}</option>`;
        if (i == currentYear) {
            break;
        }
    }
    menuYear[X].innerHTML = `<option class="default" value="" selected hidden>Vehicle Year</option>${optionString}`;
    localStorage.setItem('yearList', `<option class="default" value="" selected hidden>Vehicle Year</option>${optionString}`);
    spinOff(menuSpinner[X]);
    menuYear[X].disabled = false;
    return;
}

//fetch models from API, render and store locally
async function retrieveModels(X, Y) {
    spinOn(menuSpinner[X]);
    let optionString = '';
    let resp = await fetch(Y, options);
    let ans = await resp.json();
    ans = nameSort(ans);
    for (i = 0; i < ans.length; i++) {
        optionString = `${optionString}<option value="${ans[i].id}">${ans[i].display_name}</option>`;
    }
    menuModel[X].innerHTML = `<option class="default" value="" selected hidden>Vehicle Model</option>${optionString}`;
    localStorage.setItem('modelList', `<option class="default" value="" selected hidden>Vehicle Model</option>${optionString}`);
    spinOff(menuSpinner[X]);
    menuModel[X].disabled = false;
    return;
}

//fetch series from API, render and store locally
async function retrieveSeries(X, Y) {
    spinOn(menuSpinner[X]);
    menuLookup[X].removeEventListener('click', menuListen);
    let resp = await fetch(Y, options);
    let ans = await resp.json();
    ans = nameSort(ans);
    let optionString = '';
    for (i = 0; i < ans.length; i++) {
        optionString = `${optionString}<option value="${ans[i].id}">${ans[i].display_name}</option>`;
    }
    menuSeries[X].innerHTML = `<option class="default" value="" selected hidden>Vehicle Series</option>${optionString}`;
    localStorage.setItem('seriesList', `<option class="default" value="" selected hidden>Vehicle Series</option>${optionString}`);
    spinOff(menuSpinner[X]);
    menuSeries[X].disabled = false;
    menuLookup[X].disabled = true;
    menuLookup[X].style.cursor = 'not-allowed';
    menuLookup[X].style.opacity = '0.8';
    return;
}

//fetch fitments from API, store information in session storage, construct url/param string for filtered results and redirect
async function searchVehicle(X, Y, Z, A, B) {
    scrollText();
    let scrollStart = performance.now();
    spinOff(menuSpinner[X]);
    sessionStorage.removeItem('altFitDisclaimer')
    let modelString = '';
    if (A.length > 0) {
        modelString = A;
    } else {
        modelString = `${menuMake[X].options[menuMake[X].selectedIndex].text} ${menuYear[X].options[menuYear[X].selectedIndex].text} ${menuModel[X].options[menuModel[X].selectedIndex].text} ${menuSeries[X].options[menuSeries[X].selectedIndex].text}`;
    }
    let fitmentInfo = localStorage.getItem(`fitmentInfo${Z}`);
    if (fitmentInfo && fitmentInfo.version == version && Number(fitmentInfo.expiry) > Date.parse(now) && Z == fitmentInfo.id) {
        if (localStorage.getItem('vehicleList')) {
            let vehicleList = localStorage.getItem('vehicleList').split(',');
            if (!vehicleList.includes(`${Z}`)) {
                vehicleList.unshift(`${Z}`);
                localStorage.setItem(`vehicleList`, vehicleList.toString());
            } else {
                vehicleList.splice(vehicleList.indexOf(`${Z}`), 1);
                vehicleList.unshift(`${Z}`);
                localStorage.setItem(`vehicleList`, vehicleList.toString());
            }
        } else {
            let vehicleList = [];
            vehicleList.unshift(`${Z}`);
            localStorage.setItem(`vehicleList`, vehicleList.toString());
        }
        let destination = '';
        let filter = '';
        let idx = 0;
        let oeidx = 0;
        let runFlat = 0;
        let empty = false;
        if (productSwitch[X].checked) {
            let fits = fitmentInfo.fitments.filter(fit => fit.f_wheels.matches.length > 0 || fit.r_wheels.matches.length > 0);
            if (fits.length == 0) {
                fitmentInfo.fitments = fitmentInfo.fitments.filter(fit => fit.f_wheels.matches.length > 0 || fit.r_wheels.matches.length > 0 || fit.oe);
                empty = true;
            } else {
                fitmentInfo.fitments = fits;
            }
        }
        for (i = 0; i < fitmentInfo.fitments.length; i++) {
            if (fitmentInfo.fitments[i].oe) {
                oeidx = i;
            }
        }
        idx = fitmentInfo.fitments[oeidx].id;
        if (productSwitch[X].checked) {
            localStorage.setItem('productType', 'wheel');
            filter = `filter.v.m.wheel_spec.pcd=${fitmentInfo.wheel_spec.pcd}&filter.v.m.wheel_spec.bolt=${fitmentInfo.wheel_spec.studs}`;
            if (fitmentInfo.fitments[oeidx].f_wheels.matches.length > 0) {
                for (z = 0; z < fitmentInfo.fitments[oeidx].f_wheels.matches.length; z++) {
                    filter = `${filter}&filter.v.m.wsp.sf=${fitmentInfo.fitments[oeidx].f_wheels.matches[z]}`;
                }
                localStorage.setItem('currentRear', `false`);
            } else {
                for (z = 0; z < fitmentInfo.fitments[oeidx].r_wheels.matches.length; z++) {
                    filter = `${filter}&filter.v.m.wsp.sf=${fitmentInfo.fitments[oeidx].r_wheels.matches[z]}`;
                }
                localStorage.setItem('currentRear', `true`);
            }
            destination = `${baseUrl}wheel-lookup?${filter}`;
            if (empty) {
                destination = `${baseUrl}wheel-lookup?${filter}&filter.v.m.wsp.sf=99999`;
            }
        } else {
            localStorage.setItem('productType', 'tyre');
            if (fitmentInfo.is_run_flat) {
                runFlat = 1;
            }
            for (z = 0; z < fitmentInfo.fitments[oeidx].f_wheels.matches.length; z++) {
                filter = `${filter}&filter.v.m.tyre_spec.size_full=${fitmentInfo.fitments[oeidx].f_tyres.matches[z]}`;
            }
            filter = filter.replaceAll(' ', '+');
            filter = filter.replace('&', '');
            destination = `${baseUrl}vehicle-lookup?${filter}&filter.v.m.tyre_spec.run_flat=${runFlat}&page=1`;
        }
        localStorage.setItem('currentModel', modelString);
        localStorage.setItem('currentID', `${Z}`);
        localStorage.setItem('currentidx', `${idx}`);
        let scrollStop = performance.now();
        if (scrollStop - scrollStart > 2500) {
            errorCheck(destination);
        } else {
            setTimeout(function () {
                errorCheck(destination);
            }, (scrollStop - scrollStart))
        }
        clearTimeout(errorTimeout);
    } else {
        localStorage.removeItem(`fitmentInfo${Z}`);
        let resp = await fetch(Y, options);
        let errorTimeout = setTimeout(errorHandle, 9000, X, vehicleError);
        if (resp.status > 299 && menusbv[X].classList.value.includes('switchActive')) {
            clearTimeout(errorTimeout);
            errorHandle(X, vehicleError);
            return;
        } else {
            let validate = await resp.text();
            if (validate.includes("vehicle_id")) {
                let ans = JSON.parse(validate);
                ans.version = version;
                ans.expiry = (Date.parse(now) + (28 * 24 * 60 * 60 * 1000)).toString();
                if (B) {
                    ans.makeModel = B;
                } else {
                    ans.makeModel = `${menuMake[X].options[menuMake[X].selectedIndex].text} ${menuModel[X].options[menuModel[X].selectedIndex].text}`;
                }
                localStorage.setItem(`fitmentInfo${Z}`, JSON.stringify(ans));
                if (localStorage.getItem('vehicleList')) {
                    let vehicleList = localStorage.getItem('vehicleList').split(',');
                    if (!vehicleList.includes(`${Z}`)) {
                        vehicleList.unshift(`${Z}`);
                        localStorage.setItem(`vehicleList`, vehicleList.toString());
                    } else {
                        vehicleList.splice(vehicleList.indexOf(`${Z}`), 1);
                        vehicleList.unshift(`${Z}`);
                        localStorage.setItem(`vehicleList`, vehicleList.toString());
                    }
                } else {
                    let vehicleList = [];
                    vehicleList.unshift(`${Z}`);
                    localStorage.setItem(`vehicleList`, vehicleList.toString());
                    if (!localStorage.getItem(`vehicleList`)) {
                        localStorage.setItem(`vehicleList`, vehicleList.toString());
                    }
                }
                let destination = '';
                let filter = '';
                let idx = 0;
                let oeidx = 0;
                let runFlat = 0;
                let empty;
                if (productSwitch[X].checked) {
                    let fits = ans.fitments.filter(fit => fit.f_wheels.matches.length > 0 || fit.r_wheels.matches.length > 0);
                    if (fits.length == 0) {
                        ans.fitments = ans.fitments.filter(fit => fit.f_wheels.matches.length > 0 || fit.r_wheels.matches.length > 0 || fit.oe);
                        empty = true;
                    } else {
                        ans.fitments = fits;
                    }
                }
                for (i = 0; i < ans.fitments.length; i++) {
                    if (ans.fitments[i].oe) {
                        oeidx = i;
                    }
                }
                idx = ans.fitments[oeidx].id;
                if (productSwitch[X].checked) {
                    localStorage.setItem('productType', 'wheel');
                    filter = `filter.v.m.wheel_spec.pcd=${ans.wheel_spec.pcd}&filter.v.m.wheel_spec.bolt=${ans.wheel_spec.studs}`;
                    if (ans.fitments[oeidx].f_wheels.matches.length > 0) {
                        for (z = 0; z < ans.fitments[oeidx].f_wheels.matches.length; z++) {
                            filter = `${filter}&filter.v.m.wsp.sf=${ans.fitments[oeidx].f_wheels.matches[z]}`;
                        }
                        localStorage.setItem('currentRear', `false`);
                    } else {
                        for (z = 0; z < ans.fitments[oeidx].r_wheels.matches.length; z++) {
                            filter = `${filter}&filter.v.m.wsp.sf=${ans.fitments[oeidx].r_wheels.matches[z]}`;
                        }
                        localStorage.setItem('currentRear', `true`);
                    }
                    destination = `${baseUrl}wheel-lookup?${filter}`;
                    if (empty) {
                        destination = `${baseUrl}wheel-lookup?${filter}&filter.v.m.wsp.sf=99999`;
                    }
                } else {
                    localStorage.setItem('productType', 'tyre');
                    if (ans.is_run_flat) {
                        runFlat = 1;
                    }
                    for (z = 0; z < ans.fitments[oeidx].f_tyres.matches.length; z++) {
                        filter = `${filter}&filter.v.m.tyre_spec.size_full=${ans.fitments[oeidx].f_tyres.matches[z]}`;
                    }
                    filter = filter.replaceAll(' ', '+');
                    filter = filter.replace('&', '');
                    destination = `${baseUrl}vehicle-lookup?${filter}&filter.v.m.tyre_spec.run_flat=${runFlat}&page=1`;
                }
                localStorage.setItem('currentModel', modelString);
                localStorage.setItem('currentID', `${Z}`);
                localStorage.setItem('currentidx', `${idx}`);
                let scrollStop = performance.now();
                if (scrollStop - scrollStart > 2500) {
                    errorCheck(destination);
                } else {
                    setTimeout(function () {
                        errorCheck(destination);
                    }, (scrollStop - scrollStart))
                }
                clearTimeout(errorTimeout);
            } else if (menusbv[X].classList.value.includes('switchActive')) {
                clearTimeout(errorTimeout);
                errorHandle(X, vehicleError);
                return;
            }
        }
    }
}

//submits rego to API and sends returned vehicleID to vehicle selector process
async function searchRego(X, Y) {
    scrollText();
    let scrollStart = performance.now();
    let productType = 'Tyres';
    if (productSwitch[X].checked) {
        productType = 'Wheels';
    }
    const regoEvent = new CustomEvent("rego_searched", {
        detail: {
            product_type: productType,
            search_instance: eventlocale[X]
        },
    });
    document.dispatchEvent(regoEvent);
    let regInput = menuRego[X].value.toLowerCase()
    let regoInfo = localStorage.getItem(`regoInfo${regInput}`);
    if (regoInfo) {
        regoInfo = JSON.parse(regoInfo);
    }
    if (regoInfo && regoInfo.version == version && Number(regoInfo.expiry) > Date.parse(now) && regoInfo.rego == regInput && regoInfo.state == menuStates[X].value && !reject) {
        let nameString = '';
        if (regoInfo.make && regoInfo.make.display_name) {
            nameString = `${regoInfo.make.display_name} `;
        }
        if (regoInfo.model && regoInfo.model.display_name) {
            nameString = `${nameString}${regoInfo.model.display_name} `
        }
        nameString = `${nameString}${regoInfo.display_name}`
        let reqString = `${url}/fitments/${regoInfo.id}?subscription-key=${key}`;
        let scrollStop = performance.now();
        if (scrollStop - scrollStart > 2500) {
            document.getElementById('scrollBG').style.display = 'none';
            searchVehicle(X, reqString, regoInfo.id, nameString, `${regoInfo.make.display_name} ${regoInfo.model.display_name}`);
        } else {
            setTimeout(function () {
                document.getElementById('scrollBG').style.display = 'none';
                searchVehicle(X, reqString, regoInfo.id, nameString, `${regoInfo.make.display_name} ${regoInfo.model.display_name}`);
            }, (scrollStop - scrollStart))
        }
    } else {
        if (regoInfo && regoInfo.rego == regInput) {
            localStorage.removeItem(`regoInfo${regInput}`);
            if (localStorage.getItem('regoList')) {
                let list = localStorage.getItem('regoList').split(',');
                if (list.includes(regInput)) {
                    list.splice(list.indexOf(regInput), 1)
                }
            }
        }
        let confirm = '';
        if (reject) {
            confirm = '&rejected=true';
        }
        let regoString = `${url}/live/lpn?lpn=${regInput}&state=${menuStates[X].value}&subscription-key=${key}${confirm}`
        let errorTimeout = setTimeout(errorHandle, 9000, X, vehicleError);
        let reCaptchaOptions = {
            method: 'GET',
            mode: 'cors',
            headers: {
                'recaptcha-token': Y
            }
        }
        let resp = await fetch(regoString, reCaptchaOptions);
        if (resp.status > 299 && menusbr[X].classList.value.includes('switchActive')) {
            clearTimeout(errorTimeout);
            if (resp.status == 429 || resp.status == 500) {
                errorHandle(X, vehicleError);
            } else {
                errorHandle(X, regoError);
            }
            return;
        } else {
            let validate = await resp.text();
            if (validate.includes('vehicle_id')) {
                clearTimeout(errorTimeout);
                let ans = JSON.parse(validate);
                localStorage.setItem('regoString', menuRego[X].value);
                localStorage.setItem('regoState', menuStates[X].selectedIndex);
                if (ans.id) {
                    ans.rego = regInput;
                    ans.state = menuStates[X].value;
                    ans.version = version;
                    ans.expiry = (Date.parse(now) + (5 * 365 * 24 * 60 * 60 * 1000)).toString();
                    localStorage.setItem(`regoInfo${regInput}`, JSON.stringify(ans));
                    if (localStorage.getItem('regoList')) {
                        let regoList = localStorage.getItem('regoList').split(',');
                        if (!regoList.includes(regInput)) {
                            regoList.unshift(regInput);
                            localStorage.setItem(`regoList`, regoList.toString());
                        } else {
                            regoList.splice(regoList.indexOf(regInput), 1);
                            regoList.unshift(regInput);
                            localStorage.setItem(`regoList`, regoList.toString());
                        }
                    } else {
                        let regoList = [];
                        regoList.unshift(menuRego[X].value);
                        localStorage.setItem(`regoList`, regoList.toString());
                    }
                    let nameString = '';
                    if (ans.make && ans.make.display_name) {
                        nameString = `${ans.make.display_name} `;
                    }
                    if (ans.model && ans.model.display_name) {
                        nameString = `${nameString}${ans.model.display_name} `
                    }
                    nameString = `${nameString}${ans.display_name}`
                    let reqString = `${url}/fitments/${ans.id}?subscription-key=${key}`;
                    let scrollStop = performance.now();
                    if (scrollStop - scrollStart > 2500) {
                        vConfirm(X, reqString, ans.id, nameString, `${ans.make.display_name} ${ans.model.display_name}`);
                    } else {
                        setTimeout(function () {
                            vConfirm(X, reqString, ans.id, nameString, `${ans.make.display_name} ${ans.model.display_name}`);
                        }, (scrollStop - scrollStart))
                    }
                }
            } else if (menusbr[X].classList.value.includes('switchActive')) {
                clearTimeout(errorTimeout);
                errorHandle(X, regoError);
                return;
            }
        }
    }
}

//trigger popup when API call receives an error
function errorHandle(X, Y) {
    document.getElementById('scrollBG').style.display = 'none';
    spinOff(menuSpinner[X]);
    overlay.style.display = 'block';
    popup.style.display = 'block';
    Y.style.display = 'block';
    return;
}

function opacityChange(X, Y) {
    X.style.opacity = Y;
}

//listeners to switch between vehicle and rego search
function changeSearchListener(X, Y, Z) {
    if (X) {
        X.addEventListener('click', function () {
            if (!X.classList.value.includes('switchActive')) {
                Y[Y.indexOf(X)].style.display = 'block';
                Z[Y.indexOf(X)].style.display = 'block';
                Z[Y.indexOf(X)].style.opacity = 1;
                for (i = 0; i < Y.length; i++) {
                    if (i == Y.indexOf(X)) {
                        continue;
                    }
                    if (Y[i]) {
                        Z[i].style.display = 'none';
                        setTimeout(opacityChange, 500, Z[i], 0);
                        if (Y[i].classList.value.includes('switchActive')) {
                            Y[i].classList.toggle('switchActive');
                            Y[i].classList.toggle('switchOff');
                        }
                    }
                }

                setTimeout(() => {
                    Y[Y.indexOf(X)].style.opacity = 1;
                }, this.animationDelay + 20);
                X.classList.toggle('switchActive');
                X.classList.toggle('switchOff');
            }
        });
    }
}

//clear stored selection and lists when dropdown value changes
function storageWiper(X) {
    let storageArray = ['seriesList', 'seriesSelection', 'modelList', 'modelSelection', 'yearList', 'yearSelection']
    for (i = 0; i < X; i++) {
        localStorage.removeItem(storageArray[i]);
    }
}

//disable unpopulated dropdowns when earlier dropdown value changes
function dropDownSwitches(X, Y) {
    let switchArray = [menuSeries[Y], menuModel[Y], menuYear[Y]]
    for (i = 0; i < X; i++) {
        switchArray[i].disabled = true;
        switchArray[i].options[switchArray[i].selectedIndex].selected = false;
    }
}

//populate years dropdown when make dropdown value is selected
function makeMove(X) {
    let makeIndex = menuMake[X].options[menuMake[X].selectedIndex].dataset.idx;
    if (localStorage.getItem('yearList')) {
        menuYear[X].innerHTML = localStorage.getItem('yearList');
        menuYear[X].disabled = false;
        if (localStorage.getItem('yearSelection')) {
            menuYear[X].selectedIndex = localStorage.getItem('yearSelection');
            yearMove(X);
        }
    } else {
        retrieveYears(X, makeIndex);
    }
}

//populate models dropdown when years dropdown value is selected
function yearMove(X) {
    if (localStorage.getItem('modelList')) {
        menuModel[X].innerHTML = localStorage.getItem('modelList');
        menuModel[X].disabled = false;
        if (localStorage.getItem('modelSelection')) {
            menuModel[X].selectedIndex = localStorage.getItem('modelSelection');
            modelMove(X);
        }
    } else if (menuYear[X].value) {
        let reqString = `${url}/models/${menuMake[X].value}?year=${menuYear[X].value}&subscription-key=${key}`;
        retrieveModels(X, reqString);
    }
}

//populate series dropdown when models dropdown value is selected
function modelMove(X) {
    if (localStorage.getItem('seriesList')) {
        menuSeries[X].innerHTML = localStorage.getItem('seriesList');
        menuSeries[X].disabled = false;
        if (localStorage.getItem('seriesSelection')) {
            menuSeries[X].selectedIndex = localStorage.getItem('seriesSelection');
            seriesMove(X);
        }
    } else if (menuModel[X].value) {
        let reqString = `${url}/series/${menuModel[X].value}?year=${menuYear[X].value}&subscription-key=${key}`;
        retrieveSeries(X, reqString);
    }
}

//enable search button when series dropdown value is selected
function seriesMove(X) {
    if (menuSeries[X].value) {
        menuLookup[X].style.cursor = 'pointer';
        menuLookup[X].style.opacity = '1';
        menuLookup[X].disabled = false;
        menuLookup[X].addEventListener('click', menuListen);
    } else {
        menuLookup[X].style.cursor = 'not-allowed';
        menuLookup[X].style.opacity = '0.8';
        menuLookup[X].disabled = true;
        menuLookup[X].removeEventListener('click', menuListen);
    }
}

//listen for click on search
function menuListen() {
    let instance = menuLookup.indexOf(this);
    if (menuSeries[instance].value.length > 0) {
        let vehicleID = menuSeries[instance].value;
        let reqString = `${url}/fitments/${vehicleID}?subscription-key=${key}`;
        localStorage.setItem('makeSelection', menuMake[instance].selectedIndex);
        localStorage.setItem('yearSelection', menuYear[instance].selectedIndex);
        localStorage.setItem('modelSelection', menuModel[instance].selectedIndex);
        localStorage.setItem('seriesSelection', menuSeries[instance].selectedIndex);
        searchVehicle(instance, reqString, vehicleID, '');
    }
}

//activate loading spinner
function spinOn(X) {
    if (X.classList.contains('hidden')) {
        X.classList.remove('hidden');
    }
}

//deactivate loading spinner
function spinOff(X) {
    if (!X.classList.contains('hidden')) {
        X.classList.add('hidden');
    }
}

//sort API results alphabetically
function nameSort(X) {
    X.sort(function (a, b) {
        var textA = a.display_name.toUpperCase();
        var textB = b.display_name.toUpperCase();
        return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
    });
    return X;
}

async function pastVehicle(X, Y, Z, A) {
    let checker = false;
    for (i = 0; i < productSwitch.length; i++) {
        if(!productSwitch[i]) {
            continue;
        }
        if (productSwitch[i].id && A.innerHTML.includes(`"${productSwitch[i].id}"`)) {
            if (productSwitch[i].checked) {
                checker = true;
            }
            break;
        }
    }
    scrollText();
    let scrollStart = performance.now();
    let fitmentInfo
    if (localStorage.getItem(`fitmentInfo${X}`)) {
        fitmentInfo = localStorage.getItem(`fitmentInfo${X}`);
    }
    if (fitmentInfo && fitmentInfo.version == version && Number(fitmentInfo.expiry) > Date.parse(now) && Z == fitmentInfo.id) {
        if (typeof fitmentInfo == 'string') {
            fitmentInfo = JSON.parse(fitmentInfo);
        }
    } else {
        let title = localStorage.getItem(`fitmentInfo${X}`);
        localStorage.removeItem(`fitmentInfo${X}`);
        let reqString = `${url}/fitments/${X}?subscription-key=${key}`;
        let resp = await fetch(reqString, options);
        let errorTimeout
        if (document.getElementById('spinner')) {
            errorTimeout = setTimeout(errorHandle, 9000, Z, vehicleError);
        } else if (document.getElementById('mobmenu-spinner')) {
            errorTimeout = setTimeout(errorHandle, 9000, Z, vehicleError);
        } else {
            errorTimeout = setTimeout(errorHandle, 9000, Z, vehicleError);
        }
        if (resp.status > 299 && G.classList.value.includes('switchActive')) {
            clearTimeout(errorTimeout);
            if (vehicleError) {
                errorHandle(Z, vehicleError);
            } else if (document.getElementById('mobMenu-searchContainer')) {
                errorHandle(Z, vehicleError);
            } else {
                errorHandle(Z, vehicleError);
            }
            return;
        }
        let validate = await resp.text();
        if (validate.includes("vehicle_id")) {
            if (title) {
                if (typeof title == 'string') {
                    title = JSON.parse(title);
                }
                title = title.makeModel;
            }
            let ans = JSON.parse(validate);
            ans.version = version;
            ans.makeModel = title;
            ans.expiry = (Date.parse(now) + (28 * 24 * 60 * 60 * 1000)).toString();
            localStorage.setItem(`fitmentInfo${X}`, JSON.stringify(ans));
            fitmentInfo = ans;
        }
    }
    let filter = '';
    let runFlat = 0;
    if (fitmentInfo.is_run_flat) {
        runFlat = 1;
    }
    let empty = false;
    if (checker) {
        let fits = fitmentInfo.fitments.filter(fit => fit.f_wheels.matches.length > 0 || fit.r_wheels.matches.length > 0);
        if (fits.length == 0) {
            fitmentInfo.fitments = fitmentInfo.fitments.filter(fit => fit.f_wheels.matches.length > 0 || fit.r_wheels.matches.length > 0 || fit.oe);
            empty = true;
        } else {
            fitmentInfo.fitments = fits;
        }
    }
    let idx = 0;
    let oeidx = 0;
    for (i = 0; i < fitmentInfo.fitments.length; i++) {
        if (fitmentInfo.fitments[i].oe) {
            idx = fitmentInfo.fitments[i].id;
            oeidx = i;
        }
    }
    let destination
    if (checker) {
        localStorage.setItem('productType', 'wheel');
        filter = `filter.v.m.wheel_spec.pcd=${fitmentInfo.wheel_spec.pcd}&filter.v.m.wheel_spec.bolt=${fitmentInfo.wheel_spec.studs}`;
        if (fitmentInfo.fitments[oeidx].f_wheels.matches.length > 0) {
            for (z = 0; z < fitmentInfo.fitments[oeidx].f_wheels.matches.length; z++) {
                filter = `${filter}&filter.v.m.wsp.sf=${fitmentInfo.fitments[oeidx].f_wheels.matches[z]}`;
            }
            localStorage.setItem('currentRear', `false`);
        } else {
            for (z = 0; z < fitmentInfo.fitments[oeidx].r_wheels.matches.length; z++) {
                filter = `${filter}&filter.v.m.wsp.sf=${fitmentInfo.fitments[oeidx].r_wheels.matches[z]}`;
            }
            localStorage.setItem('currentRear', `true`);
        }
        destination = `${baseUrl}wheel-lookup?${filter}`;
        if (empty) {
            destination = `${baseUrl}wheel-lookup?${filter}&filter.v.m.wsp.sf=99999`;
        }
    } else {
        localStorage.setItem('productType', 'tyre');
        for (z = 0; z < fitmentInfo.fitments[oeidx].f_tyres.matches.length; z++) {
            filter = `${filter}&filter.v.m.tyre_spec.size_full=${fitmentInfo.fitments[oeidx].f_tyres.matches[z]}`;
        }
        filter = filter.replaceAll(' ', '+');
        filter = filter.replace('&', '');
        destination = `${baseUrl}vehicle-lookup?${filter}&filter.v.m.tyre_spec.run_flat=${runFlat}&page=1`;
        localStorage.setItem('currentRear', `false`);
    }
    localStorage.setItem('currentModel', `${Y}+${fitmentInfo.display_name}`);
    localStorage.setItem('currentID', `${X}`);
    localStorage.setItem('currentidx', `${idx}`);
    let scrollStop = performance.now();
    if (scrollStop - scrollStart > 2500) {
        errorCheck(destination);
    } else {
        setTimeout(function () {
            errorCheck(destination);
        }, (scrollStop - scrollStart))
    }
}

function vConfirm(X, Y, Z, A, B) {
    document.getElementById('scrollBG').style.display = 'none';
    spinOff(menuSpinner[X]);
    if (reject) {
        document.getElementById('vName').innerHTML = A;
        document.getElementById('vConfirmNo').innerHTML = 'No';
        overlay.style.display = 'block';
        popup.style.display = 'block';
        vehicleConfirm.style.display = 'block';
        confirmListeners(X, Y, Z, A, B);
    } else {
        document.getElementById('vName').innerHTML = A;
        overlay.style.display = 'block';
        popup.style.display = 'block';
        vehicleConfirm.style.display = 'block';
        confirmListeners(X, Y, Z, A, B);
    }

}

function confirmListeners(X, Y, Z, A, B) {
    document.getElementById('vConfirmYes').addEventListener('click', function () {
        overlay.style.display = 'none';
        popup.style.display = 'none';
        vehicleConfirm.style.display = 'none';
        searchVehicle(X, Y, Z, A, B);
    });
    document.getElementById('vConfirmYesMob').addEventListener('click', function () {
        overlay.style.display = 'none';
        popup.style.display = 'none';
        vehicleConfirm.style.display = 'none';
        searchVehicle(X, Y, Z, A, B);
    });
    document.getElementById('vConfirmNo').addEventListener('click', function () {
        if (reject) {
            localStorage.removeItem(`regoInfo${Z}`);
            noReject(X);
        } else {
            localStorage.removeItem(`regoInfo${Z}`);
            reject = true;
            overlay.style.display = 'none';
            popup.style.display = 'none';
            vehicleConfirm.style.display = 'none';
            onFind(X);
        }
    });
    document.getElementById('vConfirmNoMob').addEventListener('click', function () {
        if (reject) {
            localStorage.removeItem(`regoInfo${Z}`);
            noReject();
        } else {
            localStorage.removeItem(`regoInfo${Z}`);
            reject = true;
            overlay.style.display = 'none';
            popup.style.display = 'none';
            vehicleConfirm.style.display = 'none';
            onFind(X);
        }
    });
}

function noReject(X) {
    if (!menusbv[X].classList.value.includes('switchActive')) {
        menuRegoFilters[X].style.display = 'none';
        menuVehicleFilters[X].style.display = 'block';
        setTimeout(() => {
            menuRegoFilters[X].style.opacity = 0;
        }, this.animationDelay + 10);
        setTimeout(() => {
            menuVehicleFilters[X].style.opacity = 1;
        }, this.animationDelay + 20);
        menusbr[X].classList.toggle('switchActive');
        menusbv[X].classList.toggle('switchActive');
        menusbr[X].classList.toggle('switchOff');
        menusbv[X].classList.toggle('switchOff');
    }
    overlay.style.display = 'none';
    popup.style.display = 'none';
    vehicleConfirm.style.display = 'none';
}

//reCaptcha call
function onFind(X) {
    if (reject) {
        grecaptcha.reset();
    }
    searchCarry = X;
    grecaptcha.execute();
};

//reCaptcha followUp function
function onSearch(token) {
    searchRego(searchCarry, token);
}